

































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AdminApi, IAdminUserRegistration, MailType } from "@/core/admin";

interface IHeader {
	text: string;
	value: string;
	align?: "start" | "center" | "end" | "left" | "right";
	sortable?: boolean;
	filterable?: boolean;
	divider?: boolean;
	class?: string | string[];
	width?: string | number;
	filter?: (value: any, search: string, item: any) => boolean;
	sort?: (a: any, b: any) => number;
}

@Component
export default class Mail extends Vue {

	public Data: IAdminUserRegistration[] = [];
	public Headers: IHeader[] = [];

	public Selected: IAdminUserRegistration[] = [];
	public Snackbar: string | false = false;

	constructor() {
		super();
	}

	public async SendMail(type: string, locale: string) {
		await this.performAsyncWithErrorHandling(
			async () => {
			const userId = this.Selected[0].ID;
			const api = new AdminApi(k => this.$tc(k));
			await api.sendMail(userId, type as MailType, locale);
			});
		return this.loadData();
	}
	public async CancelReg() {
		await this.performAsyncWithErrorHandling(
			async () => {
			const userId = this.Selected[0].ID;
			const api = new AdminApi(k => this.$tc(k));
			await api.cancelReg(userId);
			});
		return this.loadData();
	}
	public async AnullReg() {
		if (confirm(`${this.$tc("admin_anull_reg_confirm")}\n${this.Selected[0].TotalCost}`)) {
			await this.performAsyncWithErrorHandling(
				async () => {
				const userId = this.Selected[0].ID;
				const api = new AdminApi(k => this.$tc(k));
				await api.anullReg(userId);
				});
			return this.loadData();
		}
	}
	public async ResetPassword() {
		await this.performAsyncWithErrorHandling(
			async () => {
			const userId = this.Selected[0].ID;
			const api = new AdminApi(k => this.$tc(k));
			await api.resetPassword(userId);
			});
		return this.loadData();
	}
	public async InitiateManualMail() {
		//
	}
	public async GetSummary() {
		//
	}

	public mounted() {
		this.loadData();
	}

	private async performAsyncWithErrorHandling<T>(a: () => Promise<T>): Promise<T | void> {
		return new Promise<T | void>(async (resolve, reject) => {
			try {
				const res = await a();
				resolve();
			} catch (error) {
				if (error && error.message)
					this.Snackbar = error.message;
				resolve();
			}
		});
	}

	private async loadData() {


		this.Headers = [
			{ text: this.$tc("reg_status"),               value: "StatusText" },
			{ text: this.$tc("user_id"),                  value: "ID" },
			{ text: this.$tc("user_mail"),                value: "Mail" },
			// { text: this.$tc("user_lastlogin"),           value: "LastLogin" },
			// { text: this.$tc("user_failedloginattempts"), value: "FailedLoginAttempts" },
			// { text: this.$tc("user_lastfailedlogin"),     value: "LastFailedLogin" },
			{ text: this.$tc("user_firstname"),           value: "FirstName" },
			{ text: this.$tc("user_lastname"),            value: "LastName" },
			{ text: this.$tc("user_adress_zip"),          value: "Adress_Zip" },
			{ text: this.$tc("user_adress_city"),         value: "Adress_City" },
			{ text: this.$tc("user_adress_street"),       value: "Adress_Street" },
			{ text: this.$tc("user_adress_number"),       value: "Adress_Number" },
			{ text: this.$tc("user_adress_country"),      value: "Adress_Country" },
			{ text: this.$tc("user_birthdate"),           value: "Birthdate" },
			{ text: this.$tc("user_mobilephone"),         value: "MobilePhone" },
			{ text: this.$tc("user_nickname"),            value: "Nickname" },
			{ text: this.$tc("user_species"),             value: "Species" },
			{ text: this.$tc("user_profilepicture"),      value: "ProfilePicture" },
			{ text: this.$tc("user_isadmin"),             value: "IsAdmin" },
			{ text: this.$tc("user_ismailconfirmed"),     value: "IsMailConfirmed" },
			{ text: this.$tc("reg_hasdog"),               value: "HasDog" },
			{ text: this.$tc("reg_hasfursuit"),           value: "HasFursuit" },
			{ text: this.$tc("reg_arrival"),              value: "Arrival" },
			{ text: this.$tc("reg_duration"),             value: "Duration" },
			{ text: this.$tc("reg_registrationdate"),     value: "RegistrationDate" },
			{ text: this.$tc("reg_intolerances"),         value: "Intolerances" },
			{ text: this.$tc("reg_shirtamount"),          value: "ShirtAmount" },
			{ text: this.$tc("reg_shirtsize"),            value: "ShirtSize" },
			{ text: this.$tc("reg_sponsor"),              value: "Sponsor" },
			{ text: this.$tc("reg_regmailsent"),          value: "RegMailSent" },
			{ text: this.$tc("reg_totalcost"),            value: "TotalCost" },
			{ text: this.$tc("room_number"),              value: "Number" },
			{ text: this.$tc("room_groups"),              value: "Groups" },
			{ text: this.$tc("reg_accept_rules_short"),   value: "AcceptRules" },
			{ text: this.$tc("reg_accept_gdpa_short"),    value: "AcceptGdpa" },
		];

		const api = new AdminApi(k => this.$tc(k));
		const data = await api.loadAll();
		this.Data = data;
		this.Selected = [];

	}
}
